import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getAuth, applyActionCode, checkActionCode } from "firebase/auth";
import { useToast } from "../../hooks/useToast";
import { sendRegisterEmail } from "../../services/apiservices/email";
import csmGrayTextLogin from "../../assets/images/csmGrayTextLogin.png";

const VerifyEmail = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [statusText, setStatusText] = useState("Verifying your email...");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const queryParameters = new URLSearchParams(window.location.search);
    const oobCode = queryParameters.get("oobCode");

    const verifyEmail = async () => {
      if (!oobCode) {
        setLoading(false);
        setStatusText("No verification code found.");
        toast?.({
          title: "Error",
          description: "Verification code is missing.",
          variant: "destructive",
        });
        return;
      }

      try {
        const info = await checkActionCode(auth, oobCode);
        const email = info?.data?.email;

        // Apply the verification code
        await applyActionCode(auth, oobCode);
        await sendRegisterEmail(email);

        // If this tab already has a signed-in user, fully refresh their auth state
        if (auth?.currentUser) {
          await auth.currentUser.reload();
        }

        setStatusText("Email verified! You can now log in.");
        toast?.({
          title: "Success",
          description: "Email verified successfully! Please log in to continue.",
          variant: "default",
        });

        // Use a hard redirect so the dashboard tab boots with fresh auth state
        window.location.replace("/login");
        setLoading(false);
      } catch (error) {
        setLoading(false);
        setStatusText("Failed to verify email.");
        toast?.({
          title: "Error",
          description: error.message || "Verification failed.",
          variant: "destructive",
        });
      }
    };

    verifyEmail();

  }, [navigate, toast]);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f0fdf4",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <img
        src={csmGrayTextLogin}
        alt="ProTeams Logo"
        style={{
          height: "80px",
          marginBottom: "30px",
        }}
      />
      <div
        style={{
          background: "white",
          borderRadius: "10px",
          padding: "40px",
          boxShadow: "0 4px 15px rgba(0, 128, 0, 0.2)",
          textAlign: "center",
          maxWidth: "400px",
          width: "100%",
        }}
      >
        {loading && (
          <svg
            width="40"
            height="40"
            viewBox="0 0 50 50"
            style={{ animation: "spin 1s linear infinite", marginBottom: "20px" }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke="#16a34a"
              strokeWidth="5"
              strokeLinecap="round"
              strokeDasharray="31.4 31.4"
              transform="rotate(-90 25 25)"
            />
          </svg>
        )}
        <h2 style={{ color: "#065f46", fontSize: "20px" }}>{statusText}</h2>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}</style>
    </div>
  );
};

export default VerifyEmail;
